<template>
  <AuthLayout>
    <div class="text-center" role="status">
      <BaseHeading as="h1" size="headline">Verifying your account...</BaseHeading>
      <p v-if="errorMessage" class="mt-4 text-red-400" role="alert">{{ errorMessage }}</p>
      <p v-else class="mt-4 text-gray-400">Please wait while we verify your email.</p>
    </div>
  </AuthLayout>
</template>

<script setup>
  import { toDisplayError } from '~/utils/errorMessage';
  import BaseHeading from '~/components/atoms/BaseHeading.vue';
  import AuthLayout from '~/components/templates/AuthLayout.vue';
  // Add Crisp chat widget
  useHead({
    script: [
      {
        innerHTML: `
          window.$crisp=[];
          window.CRISP_WEBSITE_ID="30d15fe3-fa17-4d3d-8eb6-f58560094f9f";
          (function(){
            d=document;
            s=d.createElement("script");
            s.src="https://client.crisp.chat/l.js";
            s.async=1;
            d.getElementsByTagName("head")[0].appendChild(s);
          })();
        `,
        type: 'text/javascript'
      }
    ]
  })

  const route = useRoute();
  const router = useRouter();
  const errorMessage = ref('');
  
  onMounted(async () => {

    if (!route.query.code) {
        errorMessage.value = 'No recovery token found in the URL.';
        return;
    }
    try {
      // For email verification, we should use verifyOtp instead of exchangeCodeForSession
      const { data, error } = await useSupabaseClient().auth.verifyOtp({
        token_hash: route.query.code,
        type: 'email'
      });
      
      if (error) throw error;
      
      // Redirect to dashboard after successful confirmation
      router.push('/dashboard');
    } catch (error) {
      console.error('Verification error:', error);
      errorMessage.value = toDisplayError(error, 'Failed to verify email');
    }
  });
  </script>